import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";


export const validateUsemap = async (tokens:any, obj: any) => {

    let response = await fetch('https://icefeeds.com/featusemapvalidate/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + String(tokens.access)
        },
        body: JSON.stringify(obj),
    })
    return await response.json()    // data
}


export default function AutocOneTrgFeat(props: any) {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {name, valsArr, trgObj, setTrgObj, setUsemapExists, projUID, setUsemapRedirectURL} = props

    let isOpen:boolean = trgObj.catID
    let val = trgObj.featName || ''

    let fieldBgColor: string = isOpen ? 'white' : '#e9ecef'

    return (
        <Autocomplete
            key={1}
            value={val}

            onChange={(event, newValue) => {
                // console.log('OnChange: ', newValue)

                if (!newValue) {    // if not value ('') then all becomes empty except for cats data
                    for (let k in trgObj) {
                        if (!k.includes('cat')) {
                            if (k === 'featLOVsList') {
                                trgObj[k as keyof typeof trgObj] = []
                            } else {
                                trgObj[k as keyof typeof trgObj] = ''
                            }
                        }
                    }
                    setTrgObj((prevState: any) => {
                        return {...prevState, ...trgObj}
                    })

                    setUsemapExists(false)

                } else {
                    // getting all trg values of the trg feature
                    fetch(`${serverIP}/featusemapgettrgvals/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify({featUID: newValue.featUID}),
                    }).then(res => res.json())
                        .then((data) => {
                            // console.log(data)
                            if (data.length > 0) {
                                setTrgObj((prevState: any) => {
                                    return {...prevState, featLOVsList: data}    // setting array with Values
                                })
                            } else {     // feature has no LOVs then we must check on existing mapping:
                                setTrgObj((prevState: any) => {
                                    return {...prevState, trgValName: '_text_', trgValUID: '0'}    // setting defaults when 0 LOVs
                                })

                                // check if this trg-combination has already been mapped (exists)
                                let callObj = {projUID: projUID, trgFeatUID: newValue.featUID, trgValUID: '0'}
                                validateUsemap(authTokens, callObj).then((data) => {
                                    setUsemapExists(data.exists)
                                    if (data.exists) {
                                        setUsemapRedirectURL(`../map/${trgObj.catUID}/${newValue.featUID}/0/`)
                                    }
                                })

                            }
                        })

                    setTrgObj((prevState: any) => {
                        return {
                            ...prevState,
                            featUID: newValue.featUID,
                            featID: newValue.featID,
                            featName: newValue.featName,
                            featType: newValue.featType,
                            featStatus: newValue.featStatus,
                            featUnit: newValue.featUnit,
                        }
                    })
                }
            }}

            isOptionEqualToValue={(option, value) => option.value === value.value}

            readOnly={!isOpen}
            disablePortal
            autoHighlight
            forcePopupIcon={false}
            size="small"
            id="combo-box-demo"
            options={valsArr}
            sx={{width: 350}}
            ListboxProps={
                {style: {
                        fontSize: '0.8rem',
                        fontFamily: "'Inter', sans-serif",
                        color: 'black'
                    }}}

            renderInput={(params) =>
                <TextField
                    {...params}
                    label=""
                    style={{backgroundColor: fieldBgColor}}
                    // InputProps={{
                    //     style: {height: 30}
                    // }}
                />}

        />
    );
}
